// extracted by mini-css-extract-plugin
module.exports = {"around_right_item":"Item_around_right_item__1P7wP"};